var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIcse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_18045_3332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 56,
    height: 56,
    rx: 12,
    fill: "url(#paint0_linear_18045_3332)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 22.4412C45 22.1976 44.7932 22 44.5385 22H21.4615C21.2068 22 21 22.1976 21 22.4412V36.5588C21 36.8024 21.2068 37 21.4615 37H44.5385C44.7932 37 45 36.8024 45 36.5588V22.4412ZM24.5275 29.2971C24.2455 28.8387 24.084 28.3049 24.084 27.7353C24.084 26.031 25.5314 24.6471 27.3148 24.6471C29.0977 24.6471 30.5455 26.031 30.5455 27.7353C30.5455 28.0512 30.4957 28.356 30.4034 28.6428C30.4255 28.6631 30.4458 28.686 30.4643 28.7112L32.6515 31.75C32.7489 31.8854 32.7595 32.0615 32.6788 32.2066C32.5985 32.3518 32.4402 32.4422 32.2685 32.4413L30.9023 32.4334L30.4218 33.6559C30.3609 33.8094 30.216 33.9184 30.0457 33.9382C29.8749 33.9581 29.7069 33.8857 29.6095 33.7503L27.7062 31.1063C27.7029 31.1121 27.6988 31.1178 27.6951 31.1231L25.5078 34.1619C25.4105 34.2974 25.2425 34.3697 25.0717 34.3499C24.9009 34.3296 24.756 34.221 24.6955 34.0671L24.2146 32.845L22.8489 32.8525C22.6768 32.8534 22.5189 32.7629 22.4382 32.6178C22.3578 32.4726 22.3685 32.2966 22.4658 32.1612L24.5275 29.2971ZM33.9231 33.4706H43.1538C43.4086 33.4706 43.6154 33.2729 43.6154 33.0294C43.6154 32.7859 43.4086 32.5882 43.1538 32.5882H33.9231C33.6683 32.5882 33.4615 32.7859 33.4615 33.0294C33.4615 33.2729 33.6683 33.4706 33.9231 33.4706ZM25.1331 30.0122L23.7277 31.9653L24.5308 31.9609C24.7242 31.9596 24.8977 32.0738 24.9655 32.2468L25.2485 32.9654L26.8163 30.7869C26.1729 30.6916 25.5923 30.4146 25.1331 30.0122ZM29.9382 29.5371C29.5735 30.021 29.0663 30.4004 28.4751 30.6179L29.8689 32.5543L30.1514 31.8351C30.2197 31.6622 30.3932 31.5484 30.5862 31.5493L31.3897 31.5541L29.9382 29.5371ZM33.9231 30.8235H43.1538C43.4086 30.8235 43.6154 30.6259 43.6154 30.3824C43.6154 30.1388 43.4086 29.9412 43.1538 29.9412H33.9231C33.6683 29.9412 33.4615 30.1388 33.4615 30.3824C33.4615 30.6259 33.6683 30.8235 33.9231 30.8235ZM27.3148 25.5294C28.5882 25.5294 29.6225 26.5176 29.6225 27.7353C29.6225 28.9529 28.5882 29.9412 27.3148 29.9412C26.0409 29.9412 25.0071 28.9529 25.0071 27.7353C25.0071 26.5176 26.0409 25.5294 27.3148 25.5294ZM33.9231 28.1765H43.1538C43.4086 28.1765 43.6154 27.9788 43.6154 27.7353C43.6154 27.4918 43.4086 27.2941 43.1538 27.2941H33.9231C33.6683 27.2941 33.4615 27.4918 33.4615 27.7353C33.4615 27.9788 33.6683 28.1765 33.9231 28.1765ZM33.9231 25.5294C33.6683 25.5294 33.4615 25.3318 33.4615 25.0882C33.4615 24.8447 33.6683 24.6471 33.9231 24.6471H38.5385C38.7932 24.6471 39 24.8447 39 25.0882C39 25.3309 38.7946 25.5281 38.5412 25.5294H33.9231Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_18045_3332",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_18045_3332"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18045_3332"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_18045_3332"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_18045_3332",
    result: "effect2_dropShadow_18045_3332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_18045_3332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18045_3332",
    x1: 5,
    y1: 1,
    x2: 33,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#307915"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIcse);
export default __webpack_public_path__ + "static/media/ic_icse.be5b887c41e9722fbbbfaf262b38f14d.svg";
export { ForwardRef as ReactComponent };